module.exports = __webpack_public_path__ + "img/login_bg.71c9c226.png";